/**
 * Enhanced Image Viewer
 *
 * Declares four web-accessible-resource groups with no `use_dynamic_url`. Only one is
 * exposed to every origin — `show-review-modal.css`, matched to `<all_urls>` — so it is
 * fetchable from any page at a fixed URL. The other three (`run-embedded-enhance-*.css`)
 * are scoped to reddit.com, fandom.com and x.com respectively, and are unreachable from
 * an arbitrary origin; we probe the reddit one as a control to show that scoping working.
 *
 * Manifest verified against version 6.21.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gefiaaeadjbmhjndnhedfccdjjlgjhho';

export const enhancedImageViewer: ExtensionDefinition = {
  id: ID,
  name: 'Enhanced Image Viewer',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 60_000,
  notes:
    'One static WAR (show-review-modal.css) on every origin; the three enhance stylesheets ' +
    'are site-scoped. The all_urls stylesheet is a single conclusive fetch.',
  signals: [
    {
      id: 'war-show-review-modal-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch show-review-modal.css — the one stylesheet exposed to every origin with no ' +
        'dynamic URL. Present only when the extension is installed.',
      weight: 1,
      run: () => probeFetch(ID, 'show-review-modal.css'),
    },
    {
      id: 'control-reddit-scoped-css',
      kind: 'web-accessible-resource',
      description:
        'CONTROL: fetch run-embedded-enhance-reddit.css, scoped to reddit.com. It should ' +
        'fail from any other origin even when installed — the matches pattern excludes ' +
        'this page — demonstrating a properly scoped resource.',
      weight: 0,
      control: true,
      run: () => probeFetch(ID, 'run-embedded-enhance-reddit.css'),
    },
  ],
};
